module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-3": "",
      "tag": "h3"
    }
  }, [_vm._v("\n    User services:\n  ")]), _vm._v(" "), _vm._l((_vm.servicesList), function(service, i) {
    return _c('v-flex', {
      key: i
    }, [_c('v-flex', {
      attrs: {
        "d-inline-flex": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "mr-4": "",
        "mt-3": "",
        "tag": "h4"
      }
    }, [_vm._v("\n        #" + _vm._s(i + 1) + "\n      ")]), _vm._v(" "), _c('v-flex', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteService(service.id)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.editService(service.id, service.description, service.price, service.name)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "icon": ""
      }
    }, [_vm._v("save")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
      attrs: {
        "label": "Service name"
      },
      model: {
        value: (service.name),
        callback: function($$v) {
          _vm.$set(service, "name", $$v)
        },
        expression: "service.name"
      }
    })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
      attrs: {
        "label": "Service description"
      },
      model: {
        value: (service.description),
        callback: function($$v) {
          _vm.$set(service, "description", $$v)
        },
        expression: "service.description"
      }
    })], 1), _vm._v(" "), _c('v-flex', [(_vm.isVendor) ? _c('v-text-field', {
      attrs: {
        "label": "Price (only for vendors)",
        "type": "number"
      },
      model: {
        value: (service.price),
        callback: function($$v) {
          _vm.$set(service, "price", $$v)
        },
        expression: "service.price"
      }
    }) : _vm._e()], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Add new service",
      "append-icon": "save",
      "append-icon-cb": _vm.saveService
    },
    model: {
      value: (_vm.newServiceDescription),
      callback: function($$v) {
        _vm.newServiceDescription = $$v
      },
      expression: "newServiceDescription"
    }
  })], 1), _vm._v(" "), _c('v-flex', [(_vm.servicesList.length > 0) ? _c('v-select', {
    attrs: {
      "items": _vm.servicesList,
      "item-text": "description",
      "label": "Select service to edit checklist"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n      ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n      ")]
      }
    }], null, false, 3537881564),
    model: {
      value: (_vm.selectedService),
      callback: function($$v) {
        _vm.selectedService = $$v
      },
      expression: "selectedService"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedService) ? _c('ItemCheckList', {
    attrs: {
      "item-id": _vm.selectedService.id,
      "item-type": _vm.serviceTypeID
    }
  }) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c023efd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserServices.vue
// module id = 995
// module chunks = 1